import { render, staticRenderFns } from "./CNInfo.vue?vue&type=template&id=0b24cc06&scoped=true"
import script from "./CNInfo.vue?vue&type=script&lang=js"
export * from "./CNInfo.vue?vue&type=script&lang=js"
import style0 from "./CNInfo.vue?vue&type=style&index=0&id=0b24cc06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24cc06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b24cc06')) {
      api.createRecord('0b24cc06', component.options)
    } else {
      api.reload('0b24cc06', component.options)
    }
    module.hot.accept("./CNInfo.vue?vue&type=template&id=0b24cc06&scoped=true", function () {
      api.rerender('0b24cc06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/CNInfo.vue"
export default component.exports